import {Localization} from "core/localization/localization";

export const sharedDictionary = new Localization({
  "Click to see Health reasons": {
    "no": "Klikk for Ã¥ se helseÃ¥rsaker",
    "en": "Click to see health reasons"
  },
	"Click to see events": {
	  no: "Klikk for Ã¥ se hendelser"
	}
});
